(angular => {
  "use strict";

  angular.module("EventManualUpload").controller("EventManualUpload.FormCtrl", [
    "$q",
    "$routeParams",
    "$mdDialog",
    "$filter",
    "$scope",
    "$timeout",
    "Loader",
    "Toast",
    "EventService",
    "EventManualUploadService",
    "model",
    FormCtrl
  ]);

  function FormCtrl($q, $routeParams, $mdDialog, $filter, $scope, $timeout, Loader, Toast, eventService, EventManualUploadService, model) {
    this.model = model || {};

    eventService.current().then(event => {
      this.event = event;
    });

    this.form = ($event, model) => {
      EventManualUploadService.form($event, model, this.company.id).then(() => {});
    };

    this.setFile = result => {
      this.model.file = {
        filename: result.filename,
        base64: result.base64
      };
    };

    this.removeFile = () => {
      this.model.file = null;
    };

    this.cancel = $mdDialog.cancel;

    this.save = () => {
      if (!this.model.file) {
        Toast.show("Selecione um arquivo", "error");
        return;
      }

      Loader.add(EventManualUploadService.save(this.model).then(() => {
        Toast.show("Upload de manual cadastrado com sucesso", "success");
        $mdDialog.hide(this.model);
      })).catch(err => Toast.httpHanlder(err));
    };

  }
})(angular || {});
